<template>
  <div>
    <el-tree :props="defaultProps" accordion node-key="id" ref="tree"
             :check-strictly="true"
             :data="classA" show-checkbox>
    </el-tree>
  </div>
</template>

<script>
import {errorHandler} from '../../../utils/errorHandler'

export default {
  name: 'merchant-tree',
  props: {
    list: {
      type: String
    }
  },
  computed: {
    normalizedSize: function () {
      return this.size.trim().toLowerCase()
    }
  },
  data () {
    return {
      classA: [],
      classB: [],
      classC: [],
      classD: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      }
    }
  },
  created () {
    let school = window.sessionStorage.getItem('schoolName')
    this.$http.post(httpUrl.test + school + '/businessEntity/getList', {}).then(function (res) {
      var data = res.body.data
      for (let i = 0; i < data.length; i++) {
        if (data[i].level === 1) {
          var objA = {}
          objA.id = data[i].id
          objA.label = data[i].businessEntityName
          objA.parentId = data[i].parentId
          objA.disabled = true
          objA.children = []
          this.classA.push(objA)
        } else if (data[i].level === 2) {
          var objB = {}
          objB.id = data[i].id
          objB.label = data[i].businessEntityName
          objB.parentId = data[i].parentId
          objB.children = []
          objB.disabled = true
          this.classB.push(objB)
        } else if (data[i].level === 3) {
          var objC = {}
          objC.id = data[i].id
          objC.label = data[i].businessEntityName
          objC.parentId = data[i].parentId
          this.classC.push(objC)
        } else if (data[i].level === 4) {
          var objD = {}
          objD.id = data[i].id
          objD.label = data[i].businessEntityName
          objD.parentId = data[i].parentId
          this.classD.push(objD)
        }
      }
      for (let p = 0; p < this.classC.length; p++) {
        var arr = new Array
        for (let q = 0; q < this.classD.length; q++) {
          if (this.classD[q].parentId == this.classC[p].id) {
            arr.push(this.classD[q])
            this.classC[p].children = arr
          }
        }
      }
      for (let p = 0; p < this.classB.length; p++) {
        var arr = new Array
        for (let q = 0; q < this.classC.length; q++) {
          if (this.classC[q].parentId == this.classB[p].id) {
            arr.push(this.classC[q])
            this.classB[p].children = arr
          }
        }
      }
      for (let p = 0; p < this.classA.length; p++) {
        var arr = new Array
        for (let q = 0; q < this.classB.length; q++) {
          if (this.classB[q].parentId == this.classA[p].id) {
            arr.push(this.classB[q])
            this.classA[p].children = arr
          }
        }
      }
      // this.$http.get(httpUrl.test + school + '/role/getRoleById/' + this.id, {}).then(function (res) {
      //   var data = res.body.data
      //   this.roleName = data.roleName
      //   for (let i = 0; i < data.roleMenus.length; i++) {
      //     let obj = {}
      //     obj.id = data.roleMenus[i].menuCode
      //     obj.label = data.roleMenus[i].menuName
      //     obj.menuCode = data.roleMenus[i].menuCode
      //     this.roleMenus.push(obj)
      //   }
      //   setTimeout(() => {
      //     this.$refs.tree.setCheckedNodes(this.roleMenus)
      //   }, 100)
      // })
      //   .catch(errorHandler('获取关联权限失败'))
    })
      .catch(errorHandler('获取关联权限列表失败'))
  },
  methods: {
    getCheckedKeys () {
      this.list = this.$refs.tree.getCheckedKeys()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/common/inputs/merchant-tree.vue